const usesRouteUrls  = [

    "/es/musica-sin-copyright-youtube/",
    "/non-copyright-music/reels/",
    "/es/musica-fondo-concursos-preguntas-respuestas/",
    "/fr/musique-conferences-discours-motivants/",
    "/es/musica-fondo-obras-teatrales/",
    "/fr/musique-fond-pour-interviews/",
    "/background-music-theatre-plays/",
    "/fr/musique-pour-remises-de-prix/",
    "/es/musica-entregas-premios/",
    "/non-copyright-music/pubg/",
    "/fr/musique-pour-les-videos-immobilieres/",
    "/background-music/farewell-video/",
    "/es/musica-bares-cafeterias-pubs/",
    "/es/musica-espera-centralitas-call-centers/",
    "/fr/musique-pour-pieces-theatre/",
    "/es/musica-de-fondo-videos-de-cocina/",
    "/fr/musique-pour-linkedin/",
    "/es/musica-de-fondo-videos-de-cumpleanos/",
    "/es/musica-fondo-youtubers/",
    "/fr/musique-fond-jeux-televises/",
    "/fr/musique-pour-videos-de-voyage/",
    "/es/musica-facebook/",
    "/es/musica-fondo-videos-inmobiliarios/",
    "/background-music-linkedin/",
    "/es/musica-conferencias-charlas/",
    "/es/musica-fondo-videos-viajes/",
    "/fr/musique-noel-libre-droits/",
    "/es/musica-fondo-videos-educativos/",
    "/fr/musique-pour-instagram/",
    "/background-music/construction-video/",
    "/es/musica-cuentos-infantiles/",
    "/non-copyright-music/facebook-reels/",
    "/es/musica-fondo-entrevistas/",
    "/fr/musique-videos-educatives/",
    "/es/musica-sin-copyright-gameplays/",
    "/es/musica-fondo-audiolibros/",
    "/es/musica-fondo-clases-virtuales/",
    "/fr/musique-videos-photo-demotions/",
    "/es/musica-libre-derechos-peliculas-cine-cortometrajes/",
    "/es/musica-fondo-linkedin/",
    "/es/musica-gimnasios/",
    "/fr/musique-dambiance-cuisine-videos/",
    "/es/musica-fondo-videos-conmemorativos/",
    "/es/musica-museos-exposiciones/",
    "/es/musica-navidena/",
    "/fr/musique-contes-pour-enfants/",
    "/background-music-tv-quiz-shows/",
    "/es/musica-para-documentales/",
    "/es/musica-fondo-supermercados/",
    "/fr/musique-pour-publicite/",
    "/es/musica-fondo-videos-fotos/",
    "/fr/musique-ambiance-hotels-luxe/",
    "/background-music-interviews/",
    "/es/musica-para-podcast/",
    "/fr/musique-supermarches-magasins-alimentaires/",
    "/es/musica-peluquerias-salones-belleza/",
    "/es/musica-electronica-sin-copyright/",
    "/fr/acheter-musique-sans-parole/",
    "/es/musica-instagram/",
    "/fr/musique-fond-pharmacies/",
    "/es/musica-iglesias-cristianas/",
    "/fr/musique-pour-publicites-en-ligne/",
    "/es/musica-fondo-farmacias/",
    "/buy-music-without-lyrics/",
    "/es/musica-fondo-bancos-instituciones-financieras/",
    "/fr/musique-fond-pour-pesentations-videos/",
    "/fr/musique-pour-musees-et-expositions/",
    "/fr/musique-pour-spots-radio/",
    "/fr/musique-pour-salles-dattente/",
    "/es/musica-consultorios/",
    "/es/comprar-musica-sin-letra/",
    "/es/musica-fondo-hoteles-lujo/",
    "/fr/musique-de-mise-pour-centres-dappel-et-standards-telephoniques/",
    "/fr/musique-facebook/",
    "/background-music-banks-financial-institutions/",
    "/es/musica-para-anuncios/",
    "/fr/musique-pour-podcast/",
    "/buy-music-for-youtube-videos/",
    "/es/musica-restaurantes/",
    "/fr/musique-darriere-plan-pour-livres-audio/",
    "/fr/musique-libre-droits-pour-films/",
    "/fr/musique-pour-agences-voyage/",
    "/music-audiobooks/",
    "/background-music-children-video-story/",
    "/es/musica-pasarelas-modelaje/",
    "/es/musica-fondo-presentaciones-videos/",
    "/background-music-for-cooking-videos/",
    "/es/musica-fondo-videos-agencias-viajes/",
    "/fr/musique-pour-centres-spa-et-bienetre/",
    "/es/musica-efectos-sonido-apps/",
    "/fr/musique-pour-salons-coiffure-et-beaute/",
    "/fr/musique-pour-eglises-chretiennes/",
    "/es/musica-para-boda/",
    "/fr/musique-fond-pour-cours-virtuels/",
    "/fr/musique-pour-youtubers/",
    "/add-music-google-slides/",
    "/youtube-shorts-music/",
    "/music-awards-ceremonies/",
    "/fr/musique-dambiance-anniversaire-video/",
    "/fr/musique-pour-television/",
    "/es/musica-para-salas-de-espera/",
    "/background-music-pharmacies/",
    "/background-music-mobile-apps/",
    "/es/musica-anuncios-radio/",
    "/es/musica-fondo-clases-yoga/",
    "/on-hold-music-call-centers-business/",
    "/background-music-photo-slideshow-video/",
    "/fr/musique-pour-videos-commerciales-et-dentreprises/",
    "/background-music-museums-exhibitions/",
    "/background-music-for-twitch/",
    "/es/musica-twitch/",
    "/es/musica-fondo-spa-wellness-center/",
    "/fr/musique-fond-videos-commemoratives/",
    "/es/musica-tiktok/",
    "/es/musica-television/",
    "/fr/comment-ajouter-musique-presentation-google-slides/",
    "/background-music-online-courses/",
    "/fr/trouver-meilleure-musique-dascenseur/",
    "/fr/musique-pour-bars-cafes-pubs/",
    "/fr/musique-pour-documentaires/",
    "/music-conferences-motivational-talks/",
    "/background-music-for-youtube-ads/",
    "/buy-music-films-movies-cinema/",
    "/music-fashion-shows/",
    "/fr/musique-libre-droits-youtube/",
    "/fr/musique-yoga/",
    "/es/musica-agencias-publicidad-freelancers/",
    "/music-commercials-advertising-agencies/",
    "/es/donde-conseguir-musica-ascensor/",
    "/es/musica-audiovisuales/",
    "/es/musica-presentaciones-google-slides/",
    "/es/musica-cursos-online/",
    "/background-music-luxury-hotels/",
    "/es/musica-sin-copyright-youtube/",
    "/non-copyright-music/reels/",
    "/es/musica-fondo-concursos-preguntas-respuestas/",
    "/fr/musique-conferences-discours-motivants/",
    "/es/musica-fondo-obras-teatrales/",
    "/fr/musique-fond-pour-interviews/",
    "/background-music-theatre-plays/",
    "/fr/musique-pour-remises-de-prix/",
    "/es/musica-entregas-premios/",
    "/non-copyright-music/pubg/",
    "/fr/musique-pour-les-videos-immobilieres/",
    "/background-music/farewell-video/",
    "/es/musica-bares-cafeterias-pubs/",
    "/es/musica-espera-centralitas-call-centers/",
    "/fr/musique-pour-pieces-theatre/",
    "/es/musica-de-fondo-videos-de-cocina/",
    "/fr/musique-pour-linkedin/",
    "/es/musica-de-fondo-videos-de-cumpleanos/",
    "/es/musica-fondo-youtubers/",
    "/fr/musique-fond-jeux-televises/",
    "/fr/musique-pour-videos-de-voyage/",
    "/es/musica-facebook/",
    "/es/musica-fondo-videos-inmobiliarios/",
    "/background-music-linkedin/",
    "/es/musica-conferencias-charlas/",
    "/es/musica-fondo-videos-viajes/",
    "/fr/musique-noel-libre-droits/",
    "/es/musica-fondo-videos-educativos/",
    "/fr/musique-pour-instagram/",
    "/background-music/construction-video/",
    "/es/musica-cuentos-infantiles/",
    "/non-copyright-music/facebook-reels/",
    "/es/musica-fondo-entrevistas/",
    "/fr/musique-videos-educatives/",
    "/es/musica-sin-copyright-gameplays/",
    "/es/musica-fondo-audiolibros/",
    "/es/musica-fondo-clases-virtuales/",
    "/fr/musique-videos-photo-demotions/",
    "/fr/musique-pour-twitch/",
    "/es/musica-para-videos-corporativos/",
    "/es/musica-libre-derechos-peliculas-cine-cortometrajes/",
    "/es/musica-fondo-linkedin/",
    "/es/musica-gimnasios/",
    "/fr/musique-dambiance-cuisine-videos/",
    "/es/musica-fondo-videos-conmemorativos/",
    "/es/musica-museos-exposiciones/",
    "/es/musica-navidena/",
    "/fr/musique-contes-pour-enfants/",
    "/background-music-tv-quiz-shows/",
    "/es/musica-para-documentales/",
    "/es/musica-fondo-supermercados/",
    "/fr/musique-pour-publicite/",
    "/es/musica-fondo-videos-fotos/",
    "/fr/musique-ambiance-hotels-luxe/",
    "/background-music-interviews/",
    "/es/musica-para-podcast/",
    "/fr/musique-supermarches-magasins-alimentaires/",
    "/es/musica-peluquerias-salones-belleza/",
    "/es/musica-electronica-sin-copyright/",
    "/fr/acheter-musique-sans-parole/",
    "/es/musica-instagram/",
    "/fr/musique-fond-pharmacies/",
    "/es/musica-iglesias-cristianas/",
    "/fr/musique-pour-publicites-en-ligne/",
    "/es/musica-fondo-farmacias/",
    "/buy-music-without-lyrics/",
    "/es/musica-fondo-bancos-instituciones-financieras/",
    "/fr/musique-fond-pour-pesentations-videos/",
    "/fr/musique-pour-musees-et-expositions/",
    "/fr/musique-pour-spots-radio/",
    "/fr/musique-pour-salles-dattente/",
    "/es/musica-consultorios/",
    "/es/comprar-musica-sin-letra/",
    "/es/musica-fondo-hoteles-lujo/",
    "/fr/musique-de-mise-pour-centres-dappel-et-standards-telephoniques/",
    "/fr/musique-facebook/",
    "/background-music-banks-financial-institutions/",
    "/es/musica-para-anuncios/",
    "/fr/musique-pour-podcast/",
    "/buy-music-for-youtube-videos/",
    "/es/musica-restaurantes/",
    "/fr/musique-darriere-plan-pour-livres-audio/",
    "/fr/musique-libre-droits-pour-films/",
    "/fr/musique-pour-agences-voyage/",
    "/music-audiobooks/",
    "/background-music-children-video-story/",
    "/es/musica-pasarelas-modelaje/",
    "/es/musica-fondo-presentaciones-videos/",
    "/background-music-for-cooking-videos/",
    "/es/musica-fondo-videos-agencias-viajes/",
    "/fr/musique-pour-centres-spa-et-bienetre/",
    "/es/musica-efectos-sonido-apps/",
    "/fr/musique-pour-salons-coiffure-et-beaute/",
    "/fr/musique-pour-eglises-chretiennes/",
    "/es/musica-para-boda/",
    "/fr/musique-fond-pour-cours-virtuels/",
    "/fr/musique-pour-youtubers/",
    "/add-music-google-slides/",
    "/youtube-shorts-music/",
    "/music-awards-ceremonies/",
    "/fr/musique-dambiance-anniversaire-video/",
    "/fr/musique-pour-television/",
    "/es/musica-para-salas-de-espera/",
    "/background-music-pharmacies/",
    "/background-music-mobile-apps/",
    "/es/musica-anuncios-radio/",
    "/es/musica-fondo-clases-yoga/",
    "/on-hold-music-call-centers-business/",
    "/background-music-photo-slideshow-video/",
    "/fr/musique-pour-videos-commerciales-et-dentreprises/",
    "/background-music-museums-exhibitions/",
    "/background-music-for-twitch/",
    "/es/musica-twitch/",
    "/es/musica-fondo-spa-wellness-center/",
    "/fr/musique-fond-videos-commemoratives/",
    "/es/musica-tiktok/",
    "/es/musica-television/",
    "/fr/comment-ajouter-musique-presentation-google-slides/",
    "/background-music-online-courses/",
    "/fr/trouver-meilleure-musique-dascenseur/",
    "/fr/musique-pour-bars-cafes-pubs/",
    "/fr/musique-pour-documentaires/",
    "/music-conferences-motivational-talks/",
    "/background-music-for-youtube-ads/",
    "/buy-music-films-movies-cinema/",
    "/music-fashion-shows/",
    "/fr/musique-libre-droits-youtube/",
    "/fr/musique-yoga/",
    "/es/musica-agencias-publicidad-freelancers/",
    "/music-commercials-advertising-agencies/",
    "/es/donde-conseguir-musica-ascensor/",
    "/es/musica-audiovisuales/",
    "/es/musica-presentaciones-google-slides/",
    "/es/musica-cursos-online/",
    "/background-music-luxury-hotels/",
    "/background-music-travel-videos/",
    "/music-licensing-hair-salon/",
    "/where-get-elevator-music/",
    "/music-youtubers-use/",
    "/es/musica-anuncios-online/",
    "/fr/musique-pour-consultations-medicales/",
    "/background-music-virtual-classes/",
    "/fr/musique-banques-institutions-financieres/",
    "/buy-music-for-corporate-videos/",
    "/fr/musique-pour-restaurants/",
    "/fr/musique-application-android-ios/",
    "/es/musica-sonidos-para-videojuegos/",
    "/es/musica-shorts-youtube/",
    "/music-for-birthday-videos/",
    "/royalty-free-music-videogames/",
    "/music-documentaries/",
    "/background-music-supermarkets-food-stores/",
    "/music-facebook-videos/",
    "/es/musica-para-videos-caseros/",
    "/fr/musique-videos-amateur/",
    "/background-music-educational-videos/",
    "/christmas-music/",
    "/fr/musique-pour-salles-de-sport/",
    "/fr/youtube-shorts-musique/",
    "/background-music-yoga-classes/",
    "/background-music-real-estate-videos/",
    "/wedding-music/",
    "/license-music-client-videos-works/",
    "/fr/musique-libre-droits-pour-laudiovisuel/",
    "/background-music-spas-wellness-center/",
    "/fr/meilleur-musique-pour-mariage/",
    "/fr/musique-tiktok/",
    "/background-music-travel-agency-videos/",
    "/christian-church-music/",
    "/music-restaurants/",
    "/buy-music-for-homemade-videos/",
    "/commercial-advertising-background-music/",
    "/es/musica-fondo-anuncios-youtube/",
    "/music-radio-ads/",
    "/music-advertising-agencies-freelancers/",
    "/royalty-free-electronic-music/",
    "/add-music-instagram-videos-stories/",
    "/background-music-memorial-videos/",
    "/fr/musiques-videos-clients/",
    "/es/pablo-olondriz-autor/",
    "/pablo-olondriz/",
    "/music-fitness-center-classes-gym/",
    "/music-licensing-bars-cafeterias-pubs/",
    "/es/musica-entregas-premios/#m%C3%BAsica-para-ceremonias-de-premios-qu%C3%A9-estilo-encaja-mejor",
    "/music-tiktok/",
    "/music-medical-dental-health-care-offices/",
    "/es/nuestra-historia/",
    "/es/categoria/musica-empresas-anuncios/",
    "/es/categoria/musica-tiendas-lugares-fisicos/",
    "/es/categoria/tv-cine-otros/",
    "/fr/musique-legale-pour-gameplays/",
    "/fr/categorie/musique-entreprises-publicites/",
    "/fr/musique-cours-en-ligne/",
    "/es/musica-video-marketing/",
    "/background-music-theatre-plays/#the-influence-of-pros-in-theatrical-play",
    "/buy-music-for-podcast/",
    "/uses/",
    "/es/musica-bares-cafeterias-pubs/#d%C3%B3nde-puedes-conseguir-la-m%C3%BAsica-para-tu-bar-o-cafeter%C3%ADa",
    "/background-music-for-waiting-rooms/",
    "/fr/musique-effets-sonores-pour-jeux-video/",
    "/download-legal-background-music/",
    "/es/usos/",
    "/fr/categorie/musique-pour-medias-sociaux/",
    "/es/licenciar-musica-videos-clientes/",
    "/es/musica-sin-copyright-youtube/#se-puede-utilizar-m%C3%BAsica-gratis-para-youtube-sin-copyright",
    "/background-music-theatre-plays/#where-can-i-get-royalty-free-music",
    "/background-music-theatre-plays/#the-importance-of-music-in-theatre",
    "/es/musica-facebook/#m%C3%BAsica-para-v%C3%ADdeos-de-facebook-cu%C3%A1les-son-mis-opciones",
      //from "uses" column from 800 to 1000
  "/es/encontrar-musica-libre-derechos-similar",
  "/es/musica-anuncios-online",
  "/es/musica-discotecas-bares-de-copas",
  "/es/musica-facebook",
  "/es/musica-para-videos-caseros",
  "/fr/musique-application-android-ios",
  "/fr/musique-fond-pour-cours-virtuels",
  "/fr/musique-libre-droits-pour-laudiovisuel",
  "/fr/musique-pour-consultations-medicales",
  "/fr/musique-pour-restaurants",
  "/fr/musique-pour-salles-de-sport",
  "/fr/youtube-shorts-musique",
  "/incidental-music",
  "/license-music-client-videos-works",
  "/music-documentaries",
  "/music-facebook-videos",
  "/music-licensing-hair-salon",
  "/music-youtubers-use",
  "/where-get-elevator-music",
  "/wedding-music",
    // Newly appended from second file
    "/music-tv-production",
    "/fr/musique-pour-twitch",
    "/royalty-free-music-video-production",
    "/fr/usages",
    "/music-for-video-marketing",
    "/creative-commons-licenses",
    "/royalty-free-music-gameplays",
    "background-music-mobile-apps/#copyright-in-music-and-sound-effects",
    "musica-conferencias-charlas/#soundtrack-your-brand"
  ];

  export default usesRouteUrls;